export default function getResource(label) {
    const resources = {
        yourStatus: 'Votre statut',
        pointsText: 'Vos points',
        joinNowBtn: 'S’inscrire',
        signInBtn: 'Ouvrir une session',
        tierProgressLabel: 'Progrès sur l’échelon Beauty Insider',
        joinFreeText: 'Adhérez à notre programme de fidélisation et de récompenses GRATUIT',
        benefitShipping: '🚚 Profitez de l’expédition gratuite en tout temps',
        benefitBirthday: '🎂 Choose a birthday gift set',
        benefitPoints: '👛 Accumulez des points sur tous vos achats',
        createAccountBtn: 'Créer un compte'
    };
    return resources[label];
}
